export class ListRequest {
    leaderIdForSearch?: string|null;
    userId!:string;
    pageNotStarted!:number;
    rowsNotStarted?: number;
    pageStarted?: number;
    rowsStarted?: number;
    category?: number;

    constructor(data: ListRequest) {
        this.leaderIdForSearch = data.leaderIdForSearch || null;
        this.userId = data.userId;
        this.pageNotStarted = data.pageNotStarted;
        this.rowsNotStarted = data.rowsNotStarted || 20;
        this.pageStarted = data.pageStarted || 0;
        this.rowsStarted = data.rowsStarted || 0;
        this.category = data.category || 0;
    }
}
